export const TOE_ADMINS_GROUP = 'toe-admins';
